import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import axios from "axios";
import Loading from "../components/Loading";

export interface PhotoProps {
  id: string;
  alt_description: string;
  urls: {
    regular: string;
  };
}

export const PhotoCard = ({ photo }: { photo: PhotoProps }) => (
  <div className="w-full p-px md:p-1">
    <img
      src={photo.urls.regular}
      alt={photo.alt_description}
      className="block object-cover object-center w-full aspect-square"
    />
  </div>
);

export const PhotoList = ({ photos }: { photos: PhotoProps[] }) => (
  <div className="container px-2 py-2 mx-auto lg:pt-12 lg:px-32">
    <div className="flex flex-wrap -m-1 md:-m-2">
      {photos.map((photo) => (
        <div className="flex flex-wrap w-1/3 lg:w-1/4">
          <PhotoCard key={photo.id} photo={photo} />
        </div>
      ))}
    </div>
  </div>
);

const ExplorerPage = () => {
  const datas = [
    "People",
    "Street Photography",
    "Textures Patterns",
    "Experimental",
    "Film",
    "Architecture",
    "Arts & Culture",
    "Current Events",
    "Spirituality",
  ];
  const [photos, setPhotos] = useState<PhotoProps[]>([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [query, setQuery] = useState(
    datas[Math.floor(Math.random() * datas.length)]
  );

  const fetchPhotos = async () => {
    setQuery(datas[Math.floor(Math.random() * datas.length)]);
    const response = await axios.get(
      `https://api.unsplash.com/search/photos?page=${page}&per_page=20&query=${query}`,
      {
        headers: {
          Authorization:
            "Client-ID " + process.env.REACT_APP_UNSPLASH_ACCESS_KEY,
        },
      }
    );
    setPhotos(photos.concat(response.data.results));
    setPage(page + 1);
    setHasMore(response.headers.link.includes('rel="next"'));
    console.log(response.data);
  };

  useEffect(() => {
    fetchPhotos();
    document.title = "Explorer";
    // search.EventListener("submit", (e) => {
    //   e.preventDefault();
    //   setSearch(e.target.value);
    //   setQuery(search);
    //   console.log(search);
    // });
  }, []);

  return (
    <InfiniteScroll
      dataLength={photos.length}
      next={fetchPhotos}
      hasMore={hasMore}
      loader={<Loading />}
    >
      <div className="container mx-auto mt-[64px]">
        <div className="overflow-hidden text-gray-700 mb-16">
          <PhotoList photos={photos} />
        </div>
      </div>
    </InfiniteScroll>
  );
};

export default ExplorerPage;
